import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import CaseManagerContact from "../../components/cm/Dashboard/FullPages/CaseManagerContact";
import SideBarMain from "../../components/cm/SideBarMain";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <CaseManagerContact />
    </AppWrapper.WithSidebar>
  );
};
